/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Icon } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/upload/upload_styles';



/* ========== ~~~~~~~~~~ CTA : UPLOAD ~~~~~~~~~~ ========== */
class Upload extends Component {
   constructor(props){
       super(props);
       this.state={
           // this data will probably come in from a parent component when hooked to redux
           uploaded: false,
           fileName: ''
       }
   }

   componentDidUpdate(nextProps){
       if(this.props.fileName !== nextProps.fileName){
           if(!this.props.fileName) this.handleDiscard();
       }
   }

   handleUpload=(e)=>{
       let fileSizeMB = (e.target.files[0].size/1000000);
       if(fileSizeMB > 5){
            this.props.sendErrorMessage('The file you tried to upload exceeds 5 MB, please upload a smaller file.');
            return;
       }

       this.setState({fileName:e.target.files[0].name, uploaded: true});

       this.props.handleFileUpload(e.target.files[0]);
       e.target.value = "";
   };

   handleDiscard=()=>{
       this.setState({ uploaded: false, fileName: '' });
       this.props.handleDiscard();
   };

   renderFileName=()=>{
       if(this.props.disabled){
           return this.props.fileName ? <div className={`file-uploaded`} ><span>Updated {this.props.uploadDate}</span></div>  : `No files uploaded`
       }
       else{
           return this.state.uploaded ? <div className={`file-uploaded`} ><span className={`file-name-text`}>{this.state.fileName}</span>{!this.props.uploadDate && <span onClick={this.handleDiscard} className={`discard`}>Discard file <Icon name={`trash-alt`}/></span>}</div>  : this.props.uploadDate ? this.props.uploadDate : `No files selected`
       }
   };


    render() {
        return (
            <div className={`upload ${this.props.classes.upload}`} onClick={this.handleClick}>
                <div className={`input-button  disabled-${this.props.disabled}`}>
                    <input className={`input-file`} type={`file`} accept={this.props.accept ? this.props.accept : ``} onChange={this.handleUpload}/>
                    <div className={`button-text`}>{this.state.fileName ? this.state.fileName : this.props.fileName ? `${this.props.fileName}` :`Browse File...`}</div>
                </div>
                <span className={`file-name`}>
                    {this.renderFileName()}
                </span>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Upload);
